var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "url(#eyeClose_svg__paint0_linear_7620_30198)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94 5.08c.35-.054.705-.08 1.06-.08 3.18 0 6.17 2.29 7.91 6a15.23 15.23 0 01-.9 1.64 1 1 0 101.7 1.05 15.78 15.78 0 001.21-2.3 1.001 1.001 0 000-.79C18.9 5.91 15.1 3 11 3a7.77 7.77 0 00-1.4.12 1.014 1.014 0 10.34 2v-.04zM2.71 1.29a1.004 1.004 0 10-1.42 1.42l3.1 3.09a14.62 14.62 0 00-3.31 4.8 1 1 0 000 .8C3.1 16.09 6.9 19 11 19a9.26 9.26 0 005.05-1.54l3.24 3.25a1 1 0 001.42 0 1.002 1.002 0 000-1.42l-18-18zm6.36 9.19l2.45 2.45a2 2 0 01-2.45-2.45zM11 17c-3.18 0-6.17-2.29-7.9-6a12.09 12.09 0 012.7-3.79L7.57 9A4 4 0 0013 14.43L14.59 16A7.24 7.24 0 0111 17z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eyeClose_svg__paint0_linear_7620_30198",
    x1: 12.178,
    y1: 38.576,
    x2: 28.371,
    y2: 31.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgEyeClose;